import { EditorSelection, EditorState } from "@codemirror/state";
import { syntaxTree } from "@codemirror/language";

function chooseTargetPosition(node, transaction, range, index) {
    let targetNode = null;

    if (node.type.is("Item")) {
        targetNode = node;
    } else if (node.type.is("ItemCtrlSeq")) {
        targetNode = node.parent;
    } else if (node.type.is("Whitespace") && node.nextSibling?.type.is("Command")) {
        targetNode = node.nextSibling?.firstChild?.firstChild ?? null;
    }

    if (!targetNode?.type.is("Item")) {
        return null;
    }

    if (transaction.isUserEvent("select.pointer")) {
        return targetNode.to;
    }

    const previousHead = transaction.startState.selection.ranges[index]?.head;
    if (range.head < previousHead) {
        return Math.max(transaction.state.doc.lineAt(range.anchor).from - 1, 1);
    }

    return targetNode.to;
}

export const listItemMarker = EditorState.transactionFilter.of((transaction) => {
    if (!transaction.selection) {
        return transaction;
    }

    let selection = transaction.selection;
    for (const [index, range] of transaction.selection.ranges.entries()) {
        if (!range.empty) {
            continue;
        }

        const node = syntaxTree(transaction.state).resolveInner(range.anchor, 1);
        const pos = chooseTargetPosition(node, transaction, range, index);
        if (pos == null) {
            continue;
        }

        selection = selection.replaceRange(
            EditorSelection.cursor(pos, range.assoc, range.bidiLevel ?? undefined, range.goalColumn),
            index,
        );
    }

    if (selection !== transaction.selection) {
        return [transaction, { selection }];
    }

    return transaction;
});
